import NiceModal from "@ebay/nice-modal-react";
import Stack from "@mui/material/Stack";
import { FC } from "react";
import insuredEvent from "../../assets/images/insured-event.png";
import { useTypedTranslation } from "../hooks";
import * as Styled from "./InsuredEventLady.styled";
import { InternalButtonLink } from "./InternalButtonLink";
import { InternalLink } from "./InternalLink";
import { Modals } from "./Modals";
import { HeadingL } from "./Typography";

type InsuredEventLadyProps = Record<string, never>;

export const InsuredEventLady: FC<InsuredEventLadyProps> = () => {
    const { t } = useTypedTranslation();

    const openModal = () => {
        NiceModal.show(Modals.ModalConfirm, {
            width: 600,
            title: t("insuredEvent.reportingInsuredEvent"),
            content: () => (
                <>
                    {t("insuredEvent.workingOnReportingModal")}
                    <InternalLink variant="light" target="_blank" href={t("insuredEvent.url")}>
                        {t("insuredEvent.url")}
                    </InternalLink>
                </>
            ),
        });
    };

    return (
        <Styled.InsuredStack>
            <Styled.InsuredEventImage src={insuredEvent} alt="Insured event" />
            <Stack>
                <HeadingL>{t("insuredEvent.reportingInsuredEvent")}</HeadingL>
                <InternalButtonLink component="button" onClick={openModal}>
                    {t("insuredEvent.reportInsuredEvent")}
                </InternalButtonLink>
            </Stack>
        </Styled.InsuredStack>
    );
};
